var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"wrapper",class:_vm.classes,attrs:{"id":_vm.block.uniqueId}},[_vm._t("default",function(){return [_c('blocks-list',{attrs:{"blocks":_vm.block.blocks,"index-offset":_vm.blockIndex}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }